import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import ChatComponent from "../chat/chatbot"; 
import "./wpp.scss";
import { color } from "echarts/lib/export";

const Footer = () => {
    const [isChatOpen, setIsChatOpen] = useState(false);
    const [showLabel, setShowLabel] = useState(false);

    //posisionamiento del chat
    const buttonRef = useRef(null);
    const [chatPosition, setChatPosition] = useState({ top: 0, left: 0 });

    useEffect(() => {
      const updatePosition = () => {
        if (isChatOpen && buttonRef.current) {
          const rect = buttonRef.current.getBoundingClientRect();
          const chatWidth = 300; // Ancho del chat en px
        
          setChatPosition({
            top: rect.bottom - 20, // 10px debajo del botón
            left: rect.left + rect.width / 5 - chatWidth / 5, // centrado respecto al botón
          });
        }
      };
    
      updatePosition();
      window.addEventListener("resize", updatePosition);
      window.addEventListener("scroll", updatePosition); // por si se hace scroll
    
      return () => {
        window.removeEventListener("resize", updatePosition);
        window.removeEventListener("scroll", updatePosition);
      };
    }, [isChatOpen]);

    return (
        <React.Fragment>
            <footer>
                <Container fluid={true} className="d-none d-sm-block">
                    <Row>
                        <Col md={7} className="basicInfo" style={{marginTop:"4vh"}}>
                            <span style={{color:"#7b7d7d"}}>BASTET - TIENDA DERMATOLOGICA</span>
                            <strong className="d-block">
                                <a
                                    href="https://fanerodiag.blob.core.windows.net/tiendas/Productos_Tienda5/Producto_POLITICA DE TRATAMIENTO DE DATOS PERSONALES ANDIMAT26132138793.pdf"
                                    className="footer-link"
                                    style={{color:"#7b7d7d"}}
                                >
                                    Tratamiento de Datos Personales
                                </a>
                            </strong>
                            <a href="https://www.facebook.com/share/1CCnQ75Wt6/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-facebook fa-2x" style={{ color: "#bdc3c7" }}></i>
                            </a>
                            <a href="https://www.instagram.com/katary.software?igsh=d3JrbzdwZXg5Nzl0" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-instagram fa-2x ml-3" style={{ color: "#bdc3c7" }}></i>
                            </a>
                            <span style={{ fontSize: "0.7em", color:"##797d7f"}} className="d-block">
                                © 2021. Todos los derechos reservados.{" "}
                                <a
                                    href="http://www.katary.co"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    className="link"
                                    style={{ color: "gray" }}
                                >
                                    Katary Software Factory
                                </a>
                            </span>
                            <span style={{ color: "gray", fontSize: "0.7em" }}>
                                Powered by Bastet <br />
                            </span>
                        </Col>
                        <Col>
                            <link rel="stylesheet" href="wpp.scss" />
                            <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css" />
                            <a href="https://api.whatsapp.com/send?phone=573207889635&text=Hola,quisiera tener mas información de Bastet" className="floatwpp" target="_blank">
                                <i className="fa fa-whatsapp my-float"></i>
                            </a>
                        </Col>

                        <Col>
                          {/* Botón del chatbot estilo robótico */}
                          <div
                            ref={buttonRef}
                            style={{
                              position: "fixed",
                              top: "76px",
                              left: "20px",
                              zIndex: 9999,
                              width: "260px",
                              height: "100px",
                            }}
                            onMouseEnter={() => setShowLabel(true)}
                            onMouseLeave={() => setShowLabel(false)}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                background: "linear-gradient(145deg, #cfd8dc, #eceff1)",
                                borderRadius: "50px",
                                padding: showLabel ? "10px 20px" : "10px",
                                boxShadow: "0 6px 12px rgba(0,0,0,0.3)",
                                border: "1px solid #b0bec5",
                                cursor: "pointer",
                                transition: "all 0.3s ease",
                                overflow: "hidden",
                                maxWidth: showLabel ? "280px" : "70px",
                                whiteSpace: "nowrap"
                              }}
                              onClick={() => setIsChatOpen(!isChatOpen)}
                              id="boton-asistente"
                            >
                              <img
                                src="https://cdn-icons-png.flaticon.com/512/4712/4712100.png"
                                alt="bot"
                                style={{
                                  width: "36px",
                                  height: "36px",
                                  margin: showLabel ? "0":"5px",
                                  filter: "drop-shadow(0 0 2px #90a4ae)",
                                  marginRight: showLabel ? "10px" : "",
                                  transition: "margin 0.3s ease"
                                }}
                              />
                              <span
                                style={{
                                  opacity: showLabel ? 1 : 0,
                                  transition: "opacity 0.3s ease",
                                  color: "#263238",
                                  fontWeight: "500"
                                }}
                              >
                                Asistente Dermatológico IA
                              </span>
                            </div>
                          </div>



                          {/* Overlay oscuro cuando el chatbot está abierto */}
                          {isChatOpen && (
                            <div
                              style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100vw",
                                height: "100vh",
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                                backdropFilter: "blur(2px)", // desenfoque opcional
                                zIndex: 9998
                              }}
                              onClick={() => setIsChatOpen(false)} // permite cerrar al hacer clic fuera del modal
                            />
                          )}

                          {/* Modal del chatbot */}
                          {isChatOpen && (
                            <div
                              style={{
                                position: "fixed",
                                top: `${chatPosition.top}px`,
                                left: `${chatPosition.left}px`,
                                zIndex: 9999,
                                maxHeight: "90vh",
                                maxWidth: "90vw",
                                width: "500px",
                                overflowY: "auto",
                                overflowX: "hidden",
                                backgroundColor: "#fff",
                                borderRadius: "10px",
                                boxShadow: "0 4px 8px rgba(0,0,0,0.2)"
                              }}
                            >
                              <button
                                onClick={() => setIsChatOpen(false)}
                                style={{
                                  position: "absolute",
                                  top: "5px",
                                  right: "5px",
                                  background: "transparent",
                                  border: "none",
                                  fontSize: "16px",
                                  cursor: "pointer",
                                  zIndex: 107000
                                }}
                              >
                                
                              </button>
                              <ChatComponent />
                            </div>
                          )}
                        </Col>

                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;



